var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-content"},_vm._l((_vm.layout),function(item1,idx1){return _c('a-row',{key:idx1,attrs:{"gutter":_vm.gutter}},_vm._l((item1),function(item2,idx2){return _c('a-col',{key:`${idx1}-${idx2}`,attrs:{"span":item2}},[_c('div',{staticClass:"loading-block"})])}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }